<template>
    <div id="about">
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
            <div class="container text-center"><h1 class="text-white">О компании</h1><Breadcrumbs title="О компании"/></div>
        </section>
        <section class="section mt-2 pb-0">
            <div class="container">
                <div class="row row-grid">
                    <div class="col-lg-6 mt-3">
                        <img src="/img/theme/about.jpg" class="w-100" />
                    </div>
                    <div class="col-lg-6">
                        <tabs fill class="flex-column flex-md-row">
                            <card shadow>
                                <tab-pane>
                                    <span slot="title">
                                        <i class="fa fa-users mr-2"></i>
                                        О нас
                                    </span>
                                    <p class="description" v-html="about['UF_ABOUT']"></p>
                                </tab-pane>
                                <tab-pane>
                                    <span slot="title">
                                        <i class="fa fa-cogs mr-2"></i>
                                        Функции
                                    </span>
                                    <p class="description" v-html="about['UF_FUNC']"></p>
                                </tab-pane>
                            </card>
                        </tabs>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Tabs from "@/components/Tabs/Tabs.vue";
    import TabPane from "@/components/Tabs/TabPane.vue";
    export default {
        components: {
            Tabs,
            TabPane
        },
        data() {
            return {
                reviews: [],
                about: []
            };
        },
        mounted() {
            var paramsReviews = {
                params: {
                    count: '2',
                }
            };
            this.$axios
                .get('/rest/reviews/', paramsReviews)
                .then(response => {
                    this.reviews = response.data
                });
            this.$axios
                .get('/rest/about/')
                .then(response => {
                    this.about = response.data
                });
            this.loadInfo();
        },
        methods: {
            async loadInfo() {
                let params_2 = new Map();
                params_2.set('entity', 'pages');
                params_2.set('code', 'about');

                let seo = await this.$root.loadContent(params_2)
                this.$root.title = seo[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = seo[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            }
        }
    };
</script>
<style>
    #about .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
        background-color: var(--default);
        color:  #fff;
    }
    #about .nav-pills .nav-link {
        color:  var(--default);
    }
    #about b{
        font-family: Montserrat-Bold;
    }
</style>